import './SocialNetworks.css';

const SocialNetworks = () => {

    return (
        <div className="rounded-social-buttons">
            <a className="social-button linkedin" href="https://www.linkedin.com/in/nikos-theodoropoulos-30/" target="_blank"></a>
            <a className="social-button github" href="https://github.com/NikTheGeek1" target="_blank"></a>
            <a className="social-button facebook" href="https://www.facebook.com/profile.php?id=100011113323246" target="_blank"></a>
        </div>
    );
};

export default SocialNetworks;